module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/080-iceland-33a8495d1b226af3ff8a329f7571535c.svg";